<template>
    <div v-if="loading" class="flex justify-center">
        <spinner />
    </div>

    <div v-else>
        <div v-if="false" class="box-border sm:mx-8 my-4 relative ">
            <img
                class="absolute left-0 inset-y-0 w-12"
                style="transform: translateX(-40%);"
                :src="imgGift"
            />
            <div
                class="w-full text-center text-red border border-red rounded font-bold sm:text-2xl px-6 py-2"
                style="background: rgba(255, 60, 36, 0.08)"
            >
                {{ $t('preview.product.welcome.message') }}
            </div>
            <img
                class="absolute right-0 inset-y-0 w-12"
                style="transform: translateX(40%);"
                :src="imgGift"
            />
        </div>
        <Home />
    </div>
</template>

<script>
import Home from './Home.vue';
import spinner from '../../components/spinner.vue';
import imgGift from '@/assets/img/gift.png';

export default {
    components: {
        Home,
        spinner
    },
    data() {
        return {
            loading: false,
            imgGift: imgGift
        };
    },
    async created() {
        if (!this.$store.state.previewCmpy) {
            this.loading = true;
            const result = await this.$store.dispatch(
                'getPreviewProducts',
                this.$route.params.cmpyToken
            );
            if (!result || !result.company || !result.shoppingList) {
                this.$router.push('/login');
            }
            this.loading = false;
        }
    }
};
</script>
